// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/progressImg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/saving-money.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Protest+Guerrilla&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentProgressBg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  z-index: 10;
}
.PaymentProgressBg h1 {
  color: var(--TextColor);
}
.PaymentProgressBg .paymentContainer {
  width: 25rem;
  display: flex;
  height: 30rem;
  border-radius: 1.25rem;
  padding: 1.25rem 1rem;
  background-color: var(--Foreground);
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
}
.PaymentProgressBg .paymentContainer .progressBarContainer {
  width: 80%;
  height: 2rem;
  background-color: #D9D9D9;
  border-radius: 1.25rem;
}
.PaymentProgressBg .paymentContainer .progressBarContainer .progressBar {
  height: 100%;
  transition: width 1s linear;
  border-radius: 1.25rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}
.PaymentProgressBg .paymentContainer p {
  font-size: 0.8rem;
  color: var(--TextColor);
  text-align: center;
  text-wrap: pretty;
}
.PaymentProgressBg .paymentContainer .timer {
  width: 100%;
  height: 100%;
  background-color: var(--Foreground);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.PaymentProgressBg .paymentContainer .timer .backGroundImg {
  flex: 1 1;
  height: 100%;
  width: 100%;
  position: relative;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.PaymentProgressBg .paymentContainer .timer .backGroundImg .timerContText {
  position: absolute;
  top: 71%;
  left: 46%;
  z-index: 10;
}
.PaymentProgressBg .paymentContainer .timer .backGroundImg .timerContText p {
  font-size: 0.6rem;
  font-weight: 600;
  color: var(--TextColor);
  text-align: center;
}
.PaymentProgressBg .paymentContainer .timer .backGroundImg .timerCont {
  position: absolute;
  top: 60%;
  left: 45%;
  z-index: 10;
}
.PaymentProgressBg .paymentContainer .timer .backGroundImg .timerCont p {
  color: var(--TextColor);
  font-size: 1.8rem;
  font-weight: 600;
  font-family: "Protest Guerrilla";
}`, "",{"version":3,"sources":["webpack://./src/Components/ReusableComponents/PaymentProgress.scss"],"names":[],"mappings":"AAGA;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EAEA,0BAAA;EACA,WAAA;AAFJ;AAGI;EACI,uBAAA;AADR;AAGI;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AADR;AAEQ;EACI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;AAAZ;AACY;EACI,YAAA;EACA,2BAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;AAChB;AAEQ;EACI,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AAAZ;AAEQ;EACI,WAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAAZ;AACY;EACI,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAAA;AAChB;AAAgB;EACI,kBAAA;EAGA,QAAA;EACA,SAAA;EAEA,WAAA;AADpB;AAGoB;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AADxB;AAIgB;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AAFpB;AAGoB;EACI,uBAAA;EACA,iBAAA;EAEI,gBAAA;EAEA,gCAAA;AAH5B","sourcesContent":["// @import url('http://www.styleseven.com');\n@import url('https://fonts.googleapis.com/css2?family=Protest+Guerrilla&display=swap');\n// @import url(\"https://fonts.googleapis.com/css2?family=Orbitron:wght@400..900&display=swap\");\n.PaymentProgressBg{\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0,0,0,.7);\n    // background: #2C2C2C50;\n    backdrop-filter: blur(5px);\n    z-index: 10;\n    h1{\n        color: var(--TextColor);\n    }\n    .paymentContainer{\n        width: 25rem;\n        display: flex;\n        height: 30rem;\n        border-radius: 1.25rem;\n        padding: 1.25rem 1rem;\n        background-color: var(--Foreground);\n        flex-direction: column;\n        align-items: center;\n        gap: .6rem;\n        .progressBarContainer{\n            width: 80%;\n            height: 2rem;\n            background-color: #D9D9D9;\n            border-radius: 1.25rem;\n            .progressBar{\n                height: 100%;\n                transition: width 1s linear;\n                border-radius: 1.25rem;\n                background-image: url('../../assets/images/progressImg.svg');\n                background-repeat: no-repeat;\n                background-size: cover;\n            }\n        }\n        p{\n            font-size: .8rem;\n            color: var(--TextColor);\n            text-align: center;\n            text-wrap: pretty;\n        }\n        .timer{\n            width: 100%;\n            height: 100%;\n            background-color: var(--Foreground);\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            .backGroundImg{\n                flex: 1 1;\n                height: 100%;\n                width: 100%;\n                position: relative;\n                background-position: center;\n                background-size: contain;\n                background-repeat: no-repeat;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                background-image: url('../../assets/images/saving-money.svg');\n                .timerContText{\n                    position: absolute;\n                    // display: flex;\n                    // flex-direction: column;\n                    top: 71%;\n                    left: 46%;\n                    // align-items: center;\n                    z-index: 10;\n                    // justify-content: center;\n                    p{\n                        font-size: .6rem;\n                        font-weight: 600;\n                        color: var(--TextColor);\n                        text-align: center;\n                    }\n                }\n                .timerCont{\n                    position: absolute;\n                    top: 60%;\n                    left: 45%;\n                    z-index: 10;\n                    p{\n                        color: var(--TextColor);\n                        font-size: 1.8rem;\n                        // font-size: 1.4rem;\n                            font-weight: 600;\n                            // font-family: 'Sizenko Alexander';\n                            font-family: \"Protest Guerrilla\";\n                            // font-family: 'Orbitron';\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
